import { Toast } from "./function-call.mjs";
var stdin_default = Toast;
export {
  Toast,
  stdin_default as default
};
